<template>
  <div class="points d-flex justify-content-end">
    <div v-for="p in profiles" :key="p._id">
      <div
        v-b-tooltip.hover
        :title="p.name"
        class=" rounded-sm  px-2 py-2 mr-2 d-flex align-items-center"
        :style="'background-color:' + bgColor(p.color) + ';'"
        v-if="getPoints(p._id) > 0 || empty"
      >
        <i class="fas" :class="p.image" :style="'color:' + p.color"></i>

        <span
          :style="'line-height:0; color:' + p.color"
          class="ml-1  font-size-lg font-weight-bolder"
          >{{ getPoints(p._id) }}</span
        >
      </div>
    </div>
  </div>
</template>

<script>
//import DashboardProfiles from "@/view/layout/dashboard/DashboardProfiles";
export default {
  name: "ProfilesPoints",
  components: {},
  props: ["points", "empty"],
  computed: {
    profiles() {
      return this.$store.getters.getProfiles;
    }
  },
  methods: {
    bgColor(i) {
      let color = i.split("1)");

      return color[0] + "0.3)";
    },
    getPoints(profileId) {
      let point = this.points.find(point => point.profile == profileId);
      return point?.points ? point.points : 0;
    }
  }
};
</script>

<style lang="scss" scoped></style>
